import { render } from "./FormMember.vue?vue&type=template&id=2557c3e2&ts=true"
import script from "./FormMember.vue?vue&type=script&lang=ts"
export * from "./FormMember.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__